export const SERVER_BASE_URL = 'https://testserver0.outby.se/';
